import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import { formatDate } from '@helpers'
import React from 'react'
import { useSalonContext } from '../../../context'

export default function Delivery({ trackings }: Props) {
    const { salon } = useSalonContext()

    if (!trackings.length)
        return (
            <small>
                We're working on delivering the awards. 
                We'll send a notification to your email when a tracking number is available 
                (around {formatDate(salon.state.awards_date)}).
            </small>
        )

    return (
        <Grid gap="10px">
            <small>Your awards are now on the way to you.</small>
            {trackings.map((tracking, idx) => (
                <EmphasizedContent padding="10px" key={idx}>
                    <small>Tracking number: <a href="https://track.ukrposhta.ua/tracking_EN.html" target="_blank">{tracking.number}</a>.</small>
                    {tracking.comment && <small>{tracking.comment}</small>}
                </EmphasizedContent>
            ))}
        </Grid>
    )
}

interface Props {
    trackings: Customer.Resources.Tracking[]
}